import moment from 'moment'
import { FaInfoCircle, FaStar, FaRegStar, FaStarHalf } from 'react-icons/fa'
import { FcGoogle } from 'react-icons/fc'
import { SiTrustpilot } from 'react-icons/si'
import StarRating from './StarRating'
import StarRatingPopup from './StarRatingPopup'

function ReviewItem({ icon, reviews, extraClasses = '' }) {
  return (
    <div className={`flex items-center px-1 ${extraClasses}`}>
      {icon}
      <span className='text-[#405985] text-[8px] sm:text-xs font-medium leading-normal px-1'>
        {reviews}
      </span>
    </div>
  )
}

interface ReviewsSummary {
  overrall_rating: number
  num_of_reviews: number
  num_of_meetings: number
  joining_date: string
  review_totals: {
    legal_utopia: number
    google: number
    trust_pilot: number
  }
  num_of_stars: {
    '1_star': number
    '2_star': number
    '3_star': number
    '4_star': number
    '5_star': number
  }
}

export function ProfileReviews({
  reviewsSummary,
}: {
  reviewsSummary: ReviewsSummary
}) {
  const reviewData = [
    {
      key: 'lu',
      icon: <img src='/LU-Logo.png' height={12} width={12} alt='LU Logo' />,
      reviews: `${reviewsSummary.review_totals.legal_utopia} Reviews`,
    },
    {
      key: 'google',
      icon: <FcGoogle fontSize={12} />,
      reviews: `${reviewsSummary.review_totals.google} Reviews`,
      extraClasses: 'border-l-[2px] border-[#D8D8DF]',
    },
    {
      key: 'trustpilot',
      icon: <SiTrustpilot fontSize={12} className='text-[#219653]' />,
      reviews: `${reviewsSummary.review_totals.trust_pilot} Reviews`,
      extraClasses: 'border-l-[2px] border-[#D8D8DF]',
    },
  ]

  return (
    <div className='flex justify-between md:items-end self-stretch flex-wrap mt-2 md:mt-8'>
      <h3 className='text-black text-md font-bold leading-[24px] tracking-wide p-1'>
        Reviews
      </h3>
      <div className='mt-1 mr-3 flex justify-center flex-wrap items-center gap-3 p-[10px] rounded-lg bg-[rgba(217,224,223,0.50)] w-full md:max-w-[425px] h-auto box-border'>
        <div className='h-[82px]'>
          <div className='flex items-center justify-center'>
            <span className='text-[10px] sm:text-xs font-medium leading-[24px] tracking-wide text-[#586885] me-2'>
              Overall rating
            </span>
            <StarRatingPopup numOfStars={reviewsSummary.num_of_stars}>
              <FaInfoCircle className='text-[10px] sm:text-sm' />
            </StarRatingPopup>
          </div>
          <div className='h-[24px] mt-2'>
            <div className='flex items-center justify-center gap-2'>
              <StarRating rating={reviewsSummary.overrall_rating} />
              <span className='text-black text-[10px] sm:text-[14px] font-medium leading-normal'>
                {reviewsSummary.overrall_rating}
              </span>

              <StarRatingPopup numOfStars={reviewsSummary.num_of_stars}>
                <sup>
                  <FaInfoCircle className='text-[10px] sm:text-sm text-[#37A2BA]' />
                </sup>
              </StarRatingPopup>
            </div>
          </div>
          <div className='flex items-center sm:justify-between mt-2'>
            {reviewData.map((item) => (
              <ReviewItem
                key={item.key}
                icon={item.icon}
                reviews={item.reviews}
                extraClasses={item.extraClasses}
              />
            ))}
          </div>
        </div>
        <div className='h-[72px] text-[#586885] text-[10px] sm:text-[12px] font-medium leading-[24px] tracking-wide pl-2 border-l-[2px] border-[#D8D8DF]'>
          <p>
            <span className='fw-bold'>Joined: </span>
            {moment(reviewsSummary.joining_date).format('Do MMMM YYYY')}
          </p>
          <p>{`${reviewsSummary.num_of_reviews} reviews`}</p>
          <p>{`${reviewsSummary.num_of_meetings} meetings`}</p>
        </div>
      </div>
    </div>
  )
}
